"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetVoucher200ResponseToJSON = exports.GetVoucher200ResponseFromJSONTyped = exports.GetVoucher200ResponseFromJSON = exports.instanceOfGetVoucher200Response = void 0;
var runtime_1 = require("../runtime");
var Voucher_1 = require("./Voucher");
/**
 * Check if a given object implements the GetVoucher200Response interface.
 */
function instanceOfGetVoucher200Response(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetVoucher200Response = instanceOfGetVoucher200Response;
function GetVoucher200ResponseFromJSON(json) {
    return GetVoucher200ResponseFromJSONTyped(json, false);
}
exports.GetVoucher200ResponseFromJSON = GetVoucher200ResponseFromJSON;
function GetVoucher200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : (0, Voucher_1.VoucherFromJSON)(json['data']),
    };
}
exports.GetVoucher200ResponseFromJSONTyped = GetVoucher200ResponseFromJSONTyped;
function GetVoucher200ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': (0, Voucher_1.VoucherToJSON)(value.data),
    };
}
exports.GetVoucher200ResponseToJSON = GetVoucher200ResponseToJSON;
